import BaseModal from '@/components/BaseModal';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import './index.scss';

const LoadingGlobal = () => {
  const loadingConfig = useSelector((state: RootState) => state.LoadingConfig);

  return (
    <BaseModal show={loadingConfig.isShow}>
      <img
        src={require('@/images/common/load.gif')}
        alt=""
        className="loading-img"
      />
    </BaseModal>
  );
};

export default LoadingGlobal;
